import { render, staticRenderFns } from "./TrademarkObjectionToUsList.vue?vue&type=template&id=49c7af63&"
import script from "./TrademarkObjectionToUsList.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToUsList.vue?vue&type=style&index=0&id=49c7af63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports